import { createEvent, createStore } from "effector"
import { changeCard, deleteCard, saveCard } from "./card"
import { IScanQr, IUserBd, IUserTg } from "../types/user"
import { getUserRaiting } from "./leaders"

export const setUserInfoTg = createEvent<null | IUserTg>()
export const $userInfoTg = createStore<null | IUserTg>(null)
.on(setUserInfoTg,(_,res) => res)
.on(getUserRaiting.doneData, (state, res) => {
  if (!state) return state;
  return  {...state, raiting: res}
})


export const setUserInfoBd = createEvent<null | IUserBd>();
export const $userInfoBd = createStore<null | IUserBd>(null)
.on(setUserInfoBd, (_, res) => res)
.on(saveCard.doneData, (state, res) => {
  if (!state) return state;
  
  return  {...state, bonus_account: res}
})
.on(deleteCard.doneData, (state) => {
  if (!state || !state.bonus_account) return state;

  return  {...state, bonus_account:{ ...state.bonus_account, card_number: '', balance: 0 }}
})
.on(changeCard.doneData, (state,res) => {
  if (!state || !state.bonus_account) return state;

  return  {...state, bonus_account: res}
})

export const setInitialScanQr = createEvent<IScanQr | null>();
export const $initialScanQr = createStore<IScanQr | null>(null)
.on(setInitialScanQr, (_, res) => res)
